let overlayer;
let popUpWindow;

window.aggreg8 = {
  redirectToAggreg8AddBankFlow,
  redirectToAggreg8OnDemandSyncFlow,
  redirectToAggreg8InfoSharingDeleteFlow,
  redirectToAggreg8ConsentExtendFlow,
  startAddBankSynchronizationFlow,
  startOnDemandSynchronizationFlow,
  startInfoSharingDeleteFlow,
  startConsentExtendFlow,
};

const expectedSyncUiFlowUrlParams = {
  ON_DEMAND_SYNC_FLOW: "on_demand_sync",
  ADD_BANK_UI_FLOW: "add_bank",
  DELETE_ISC_UI_FLOW: "delete_isc",
  EXTEND_CONSENT_FLOW: "extend_consent",
};

async function redirectToAggreg8AddBankFlow(
  nonAispSyncUiUrl,
  customerSyncToken,
  redirectUrl
) {
  redirectUrl = encodeRedirectUrl(redirectUrl);
  const syncUiUrl = composeSyncUiUrl(nonAispSyncUiUrl, {
    "ui-flow": expectedSyncUiFlowUrlParams.ADD_BANK_UI_FLOW,
    customerSyncToken,
    redirectUrl,
  });
  redirectToSyncUi(syncUiUrl, window);
}

async function redirectToAggreg8OnDemandSyncFlow(
  nonAispSyncUiUrl,
  customerSyncToken,
  redirectUrl,
  iscId
) {
  redirectUrl = encodeRedirectUrl(redirectUrl);
  const syncUiUrl = composeSyncUiUrl(nonAispSyncUiUrl, {
    "ui-flow": expectedSyncUiFlowUrlParams.ON_DEMAND_SYNC_FLOW,
    customerSyncToken,
    redirectUrl,
    "info-sharing-consent-id": iscId,
  });
  redirectToSyncUi(syncUiUrl, window);
}

async function redirectToAggreg8InfoSharingDeleteFlow(
  nonAispSyncUiUrl,
  customerSyncToken,
  redirectUrl,
  iscId
) {
  redirectUrl = encodeRedirectUrl(redirectUrl);
  const syncUiUrl = composeSyncUiUrl(nonAispSyncUiUrl, {
    "ui-flow": expectedSyncUiFlowUrlParams.DELETE_ISC_UI_FLOW,
    customerSyncToken,
    redirectUrl,
    "info-sharing-consent-id": iscId,
  });
  redirectToSyncUi(syncUiUrl, window);
}

async function redirectToAggreg8ConsentExtendFlow(
  nonAispSyncUiUrl,
  customerSyncToken,
  redirectUrl,
  iscId
) {
  encodeRedirectUrl(redirectUrl);
  const syncUiUrl = composeSyncUiUrl(nonAispSyncUiUrl, {
    "ui-flow": expectedSyncUiFlowUrlParams.EXTEND_CONSENT_FLOW,
    customerSyncToken,
    redirectUrl,
    "info-sharing-consent-id": iscId,
  });
  redirectToSyncUi(syncUiUrl, window);
}

async function startAddBankSynchronizationFlow(
  nonAispSyncUiUrl,
  banksApiUrl,
  customerSyncToken,
  popupClosedCallback
) {
  await startSyncUi(
    nonAispSyncUiUrl,
    banksApiUrl,
    {
      "ui-flow": expectedSyncUiFlowUrlParams.ADD_BANK_UI_FLOW,
      customerSyncToken,
    },
    customerSyncToken,
    popupClosedCallback
  );
}

async function startOnDemandSynchronizationFlow(
  nonAispSyncUiUrl,
  iscId,
  banksApiUrl,
  customerSyncToken,
  popupClosedCallback
) {
  await startSyncUi(
    nonAispSyncUiUrl,
    banksApiUrl,
    {
      "ui-flow": expectedSyncUiFlowUrlParams.ON_DEMAND_SYNC_FLOW,
      customerSyncToken,
      "info-sharing-consent-id": iscId,
    },
    customerSyncToken,
    popupClosedCallback
  );
}

async function startInfoSharingDeleteFlow(
  nonAispSyncUiUrl,
  iscId,
  banksApiUrl,
  customerSyncToken,
  popupClosedCallback
) {
  await startSyncUi(
    nonAispSyncUiUrl,
    banksApiUrl,
    {
      "ui-flow": expectedSyncUiFlowUrlParams.DELETE_ISC_UI_FLOW,
      customerSyncToken,
      "info-sharing-consent-id": iscId,
    },
    customerSyncToken,
    popupClosedCallback
  );
}

async function startConsentExtendFlow(
  nonAispSyncUiUrl,
  iscId,
  banksApiUrl,
  customerSyncToken,
  popupClosedCallback
) {
  await startSyncUi(
    nonAispSyncUiUrl,
    banksApiUrl,
    {
      "ui-flow": expectedSyncUiFlowUrlParams.EXTEND_CONSENT_FLOW,
      customerSyncToken,
      "info-sharing-consent-id": iscId,
    },
    customerSyncToken,
    popupClosedCallback
  );
}

async function startSyncUi(
  nonAispSyncUiUrl,
  banksApiUrl,
  syncUiQueryParams,
  customerSyncToken,
  popupClosedCallback
) {
  openScreenLock();
  popUpWindow = openWindow();
  const syncUiUrl = composeSyncUiUrl(nonAispSyncUiUrl, syncUiQueryParams);

  if (window.focus) {
    popUpWindow.focus();
  }

  redirectToSyncUi(syncUiUrl, popUpWindow);

  await pollingCustomerSyncToken(
    banksApiUrl,
    customerSyncToken,
    popupClosedCallback
  );

  window.addEventListener("focus", function () {
    if (popUpWindow && popUpWindow.closed) {
      composeClosingPopupWindow(popupClosedCallback, false, false);
    }
  });
}

function encodeRedirectUrl(redirectUrl) {
  const encoded = redirectUrl !== decodeURIComponent(redirectUrl);
  if (!encoded) {
    redirectUrl = encodeURIComponent(redirectUrl);
  }
  return redirectUrl;
}

function openScreenLock() {
  overlayer = Overlayer();
  overlayer.show();
}

function openWindow() {
  const width = 450;
  const height = 725;
  const left = (screen.width - width) / 2;
  const top = (screen.height - height) / 4;
  return window.open(
    "",
    "about",
    "resizable=no, toolbar=no, scrollbars=yes, menubar=no, width=" +
      width +
      ", height=" +
      height +
      ", top=" +
      top +
      ", left=" +
      left
  );
}

function composeSyncUiUrl(nonAispSyncUiUrl, queryParams) {
  let queries = "";
  for (const property in queryParams) {
    queries += `&${property}=${queryParams[property]}`;
  }
  queries = queries.replace(/^&/, "?");
  return nonAispSyncUiUrl + queries;
}

function redirectToSyncUi(syncUiUrl, currentWindow) {
  currentWindow.location.href = syncUiUrl;
}

function composeClosingPopupWindow(popupClosedCallback, isForced, doCallback) {
  closeScreenLock();
  popUpWindow = null;
  if (doCallback) {
    popupClosedCallback(isForced);
  }
}

function closeScreenLock() {
  if (overlayer) {
    overlayer.hide();
  }
}

async function pollingCustomerSyncToken(
  banksApiUrl,
  customerSyncToken,
  popupClosedCallback
) {
  const xhr = new XMLHttpRequest();
  const syncIdUrl =
    banksApiUrl + "/synctask?customerSyncToken=" + customerSyncToken;

  await wait(1000);

  xhr.open("GET", syncIdUrl, false);
  xhr.send(null);

  const resJson = JSON.parse(xhr.responseText);
  const shouldDoPolling = resJson.shouldDoPolling;

  if (!shouldDoPolling || !popUpWindow || popUpWindow.closed) {
    closePopupWindow(
      popupClosedCallback,
      resJson.status !== "SYNC_COMPLETE" && resJson.status !== "CONSENT_GIVEN"
    );
  } else {
    await pollingCustomerSyncToken(
      banksApiUrl,
      customerSyncToken,
      popupClosedCallback
    );
  }
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function closePopupWindow(popupClosedCallback, isForced) {
  if (popUpWindow) {
    popUpWindow.close();
  }
  composeClosingPopupWindow(popupClosedCallback, isForced, true);
}

function Overlayer() {
  const cleanups = [];
  const el = document.createElement("div");
  const style =
    "position:fixed;width:100%;height:100%;top:0px;left:0px;background:rgba(20,20,20,0.8);z-index:1001;";
  el.setAttribute("style", style);
  return {
    el: el,
    show: show,
    hide: hide,
    destroy: destroy,
  };

  function show() {
    el.style.opacity = 0;
    fade(1);
  }

  function hide() {
    el.style.opacity = 1;
    fade(0);
  }

  function destroy() {
    stop();
    if (el.parentElement) el.parentElement.removeChild(el);
  }

  function stop() {
    while (cleanups.length) cleanups.pop()();
  }

  function fade(opacity) {
    stop();
    document.body.appendChild(el);
    el.style.opacity = opacity;
    if (!opacity) destroy();
  }
}
